import "./index.scss";
import React from "react";
import { useSelector } from "react-redux";

import {
  selectIsSold,
  selectSellingStatus,
} from "../../store/features/auctionSlice";
import { Avatar } from "../atoms";

// Who is holding the bid, or who bought the player. The franchise's own colour
// appears only as the small marker beside its name, so twelve teams cannot
// turn the page into twelve colour schemes.
const TeamBidding = ({ player }) => {
  const isSold = useSelector(selectIsSold);
  const sellingStatus = useSelector(selectSellingStatus);

  if (sellingStatus === "no bids") return null;

  const franchise = player?.lastBidBy?.franchise;
  const team = player?.lastBidBy?.team;
  const owner = player?.lastBidBy?.owner;
  const unsold = sellingStatus === "unsold";

  return (
    <section className={`bidder-card ${isSold ? "is-sold" : ""}`}>
      <span className="au-label">{isSold ? "Sold to" : "Bid by"}</span>

      {unsold || !team ? (
        <p className="bidder-none">No bids yet</p>
      ) : (
        <div className="bidder-who">
          <Avatar name={team} src={franchise?.image} size={44} logo />
          <div className="bidder-text">
            <span className="bidder-team">
              {franchise?.color?.hex && (
                <span
                  className="bidder-swatch"
                  style={{ background: franchise.color.hex }}
                />
              )}
              {team}
            </span>
            {owner && <span className="bidder-owner">{owner}</span>}
          </div>
        </div>
      )}
    </section>
  );
};

export default TeamBidding;
